import api from './api';

export interface RecentSale {
    id: number;
    customerName: string;
    totalAmount: number;
    saleDate: string;
    status: string;
}

export interface DashboardStats {
    totalSales: number;
    totalOrders: number;
    totalCustomers: number;
    recentSales: RecentSale[];
}

const dashboardService = {
    getStats: async (): Promise<DashboardStats> => {
        const response = await api.get('/Dashboard');
        return response.data;
    }
};

export default dashboardService;
